const reducer = (state: WtrState, action: { payload: string }) => ({
  ...state,
  loading: false,
  dates: [],
  campaigns: {},
  error: action.payload,
});

export default reducer;
